/*
 * @Author: your name
 * @Date: 2020-12-06 17:43:25
 * @LastEditTime: 2020-12-15 14:56:39
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /shopManagement/src/router/modules/orderList.js
 */

import orderList from '@/pages/orderForChat/orderList'
import workOrder from '@/pages/orderForChat/workOrder'
import workOrderDetail from '@/pages/orderForChat/workOrderDetail'
import layout from '@/components/layout/layout'

const chatRouter =
{
  path: '/orderList',
  component: layout,
  meta: {roles: ['shop', 'r4gys'], title: '锐锢在线', icon: 'icon-tongzhigonggao'},
  children: [
    {
      path: '/orderList/work',
      component: workOrder,
      name: 'workOrder',
      meta: {roles: ['shop', 'r4gys'], title: '工单管理'}
    },
    {
      path: '/orderList/detail/',
      component: workOrderDetail,
      name: 'workOrderDetail',
      hidden: true,
      meta: {roles: ['shop', 'r4gys']}
    },
    {
      path: '/orderList/chat',
      component: orderList,
      name: 'orderList',
      meta: {roles: ['pingtai', 'zhifa','factory', 'r4gys'], title: '聊天室'}
    }
  ]
}
export default chatRouter



// WEBPACK FOOTER //
// ./src/router/modules/orderList.js